<template>
  <div>
    <v-dialog width="600px" :value="true">
      <v-card>
        <v-card-title>
          <v-layout>
            <v-flex>
              <span class="headline">{{
                $t('Terms & Condition & Refund Prolicy')
              }}</span>
            </v-flex>
            <v-flex class="text-xs-right">
              <v-btn flat fab small @click="$emit('close')">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <template v-if="$store.state.cds.includes(pageid)">
            <strong>ทางบริษัทขอสงวนสิทธิ์การเปลี่ยนหรือคืนสินค้าทุกกรณี</strong>

            <p>
              ในกรณีบริษัทฯ
              จัดส่งสินค้าผิดจากรายละเอียดยืนยันการสั่งซื้อสินค้าครั้งล่าสุด
              หรือกรณีสินค้าแตกหัก/สูญหายจากการขนส่ง บริษัทฯ
              ยินดีจะรับผิดชอบในการเปลี่ยนหรือคืนเงินให้กับลูกค้าตาม
              นโยบายการคืนเงิน *
            </p>
          </template>

          <template v-else>
            <p>
              ยินดีต้อนรับทุกท่านสู่
              <a :href="currentUrl" target="_BLANK">{{ currentUrlMin }}</a>
              เพื่อความสะดวกในการใช้งานภายในเว็บไซต์
              โปรดอ่านข้อกำหนดต่างๆเหล่านี้ก่อนการเริ่มใช้งาน
              <a :href="currentUrl" target="_BLANK">{{ currentUrlMin }}</a>
              ภายใต้บริษัท โรโบลิงโก้ จำกัด ทำการค้าภายใต้ชื่อ
              <a :href="currentUrl" target="_BLANK">{{ currentUrlMin }}</a>
              เพื่อขายและส่งเสริมการขายสินค้าของบริษัทฯ
              อีกทั้งยังเป็นช่องทางในการติดต่อสื่อสารระหว่าง ร้านกับผู้ใช้บริการ
            </p>
            <p>
              ดังนั้น กรุณาศึกษาข้อกำหนดและเงื่อนไขดังต่อไปนี้โดยละเอียด
              การเข้าเยี่ยมชมหรือใช้บริการ
              <a :href="currentUrl" target="_BLANK">{{ currentUrlMin }}</a>
              ถือว่าท่านได้ยอมรับว่าท่านได้อ่านและตกลง
              ยินยอมที่จะปฏิบัติตามข้อกำหนดและเงื่อนไขนี้
              รวมทั้งมีการผูกมัดอย่างถูกต้องตามกฎหมายกับข้อกำหนดและเงื่อนไขต่างๆ
              บริษัทฯ มีสิทธิในการแก้ไข เปลี่ยนแปลง
              หรือยกเลิกข้อกำหนดและเงื่อนไขฉบับนี้
              และ/หรือข้อตกลงอื่นใดบนเว็บไซต์นี้โดยไม่จำเป็นต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
            </p>
            <br />
            <strong>ลิขสิทธิและลิขสิทธิ์ทางปัญญา</strong>
            <p>
              ซ็อฟแวร์ โค้ดต่างๆ รูปแบบการนำเสนองาน เครื่องหมายการค้า โลโก้
              ไอคอน เนื้อหา ข้อความ ตัวหนังสือ ชื่อ และรูปภาพ สำหรับการให้บริการ
              บนเว็บไซด์นี้ เว้นแต่จะระบุที่มาจากแหล่งอื่น
              ถือเป็นทรัพย์สินทางปัญญาของ
              <a :href="currentUrl" target="_BLANK">{{ currentUrlMin }}</a>
              แต่เพียงผู้เดียว และเป็นงานที่ได้รับความคุ้มครองโดยกฎหมาย
              ห้ามผู้ใดกระทำซ้ำ ลอกเลียนแบบ ดาวน์โหลด
              หรือดัดแปลงไม่ว่าส่วนใดส่วนหนึ่งหรือทั้งหมดของเว็บไซด์นี้
              นอกจากนี้สินค้าที่จัดจำหน่ายบนเว็บไซด์
              ได้รับการคุ้มครองจากสิทธิบัตร เครื่องหมายการค้าหรือสิทธิอื่นๆ
              บริษัทฯจะไม่รับผิดใดๆ ในการละเมิดสิทธิที่ผู้อื่นกระทำขึ้น
            </p>
            <p>
              ห้ามใช้เครื่องหมายการค้า และเครื่องหมายอื่นที่เกี่ยวข้องกับ
              <a :href="currentUrl" target="_BLANK">{{ currentUrlMin }}</a>
              กับการให้บริการที่ไม่ได้เกิดจากหรือเป็นของ
              <a :href="currentUrl" target="_BLANK">{{ currentUrlMin }}</a>
              และก่อให้เกิดการเข้าใจผิดระหว่างลูกค้าหรือผู้ใช้บริการ
              รวมทั้งการกระทำใดๆที่เป็นการทำให้
              <a :href="currentUrl" target="_BLANK">{{ currentUrlMin }}</a>
              เสื่อมเสีย คำอธิบายผลิตภัณฑ์และสีของรูปภาพ
            </p>
            <p>
              บริษัทฯ จะพยายามให้คำอธิบายผลิตภัณฑ์มีความถูกต้องมากที่สุด
              อย่างไรก็ตาม
              บริษัทฯไม่สามารถรับประกันได้ว่าคำอธิบายผลิตภัณฑ์บนเว็บไซต์เหล่านั้นจะถูกต้อง
              สมบูรณ์ เชื่อถือได้ ทันกาลเวลา ปราศจากข้อผิดพลาดทั้งมวล
              เช่นเดียวกันเรื่องสีของรูปภาพ ทางบริษัทฯ
              มีความตั้งใจที่จะแสดงรูปภาพสินค้าตรงตามความเป็นจริง
              แต่สีที่แสดงบนหน้าหน้าจอของผู้ใช้บริการ
              อาจผิดเพี้ยนตามคอมพิวเตอร์ที่แตกต่างกัน และ การตั้งค่าของหน้าจอ
              ดังนั้นหากผลิตภัณฑ์ที่จัดจำหน่ายโดย
              <a :href="currentUrl" target="_BLANK">{{ currentUrlMin }}</a>
              ไม่ได้เป็นอย่างที่อธิบายไว้ บริษัทฯ
              ขอสงวนสิทธิ์ไม่รับผิดชอบต่อข้อผิดพลาดที่เกิดขึ้นทั้งมวล
              (ไม่ว่าจะเป็นการรับคืนสินค้า การเปลี่ยนสินค้า หรือการคืนเงิน)
            </p>
            <p>
              นอกจากนี้บริษัทฯ
              ขอสงวนสิทธิ์ไม่รับผิดชอบต่อความผิดพลาดในการใส่ข้อมูลที่อยู่บนเว็บไซด์นี้
              (ไม่ว่าจะเป็นการลงราคาผิด หรือ ลงรายละเอียดผิด เป็นต้น) บริษัทฯ
              มีสิทธิอย่างเต็มที่ที่จะยกเลิกคำสั่งได้ทุกเมื่อ
              และสามารถเปลี่ยนแปลงแก้ไขได้โดยมิต้องแจ้งล่วงหน้า
              การป้องกันการฉ้อโกงและการใช้งานอันไม่เหมาะสม
            </p>
            <ul class="mb-4">
              <li>
                บริษัทฯ มีสิทธิ์ที่จะปฏิเสธหรือยกเลิกการสั่งซื้อ
                หากตรวจพบบัญชีที่มีประวัติการฉ้อโกง
                และสามารถยกเลิกบัญชีของผู้ใช้บริการได้หากตรวจพบการฉ้อโกงหรือพฤติกรรมที่ผิดกฎหมาย
                บริษัทฯ บังคับใช้นโยบายดังกล่าวเพื่อปกป้องผู้ใช้บริการของเรา
                รวมทั้งบริษัทฯ เองจากการถูกต้มตุ๋น หลอกลวง
                หรือการกระทำที่ผิดกฎหมาย
              </li>
              <li>
                หากผู้ใช้บริการเว็บไซด์ของทางบริษัทฯ
                ได้มีการส่งหรือประกาศถึงเนื้อหา รูปภาพ
                หรือข้อมูลใดๆอันเป็นการขัดต่อกฎหมาย ดูหมิ่นศาสนา ทำลายชื่อเสียง
                หมิ่นประมาท หยาบคาย มุ่งร้าย ลามกอนาจาร ทำให้ผู้อื่นไม่พอใจ
                เป็นผลให้ทางบริษัทฯ
                หรือบุคคลที่สามใดๆก็ตามได้รับความเสียหายอันเนื่องมาจากเนื้อหาหรือข้อมูล
                ไม่ว่าจะทางตรงหรือทางอ้อม
                ผู้ใช้บริการท่านนั้นจะต้องเป็นผู้รับผิดชอบความเสียหาย
                รวมถึงหนี้สิน ค่าเสียหายและรายจ่ายอันเกิดขึ้นจากการที่บริษัทฯ
                หรือ บุคคลที่ 3 ต้องสูญเสียไป
              </li>
            </ul>
            <br />
            <strong>ข้อเสนอแนะ</strong>
            <p>
              บริษัทฯ ยินดีรับความคิดเห็นและข้อเสนอแนะจากท่านเกี่ยวกับเว็บไซต์
              สินค้าและบริการของบริษัทฯ
              โดยความคิดเห็นและข้อเสนอแนะดังกล่าวจะไม่ถือเป็นความลับ
              และอาจถูกนำไปใช้ ดัดแปลง ทำซ้ำ และเผยแพร่ได้เพื่อจุดประสงค์ใดๆ
              อย่างไรก็ตาม บริษัทฯ จะไม่เชื่อมโยงชื่อ
              นามสกุลของท่านกับความคิดเห็นและข้อเสนอแนะของท่าน
              โดยไม่ได้รับอนุญาตจากท่านก่อน
              เว้นแต่ในกรณีที่เป็นการขัดต่อข้อกฎหมายเท่านั้น
            </p>

            <h3>Data protection and Privacy policy</h3>
            <p>
              <a :href="currentUrl" target="_BLANK">{{ currentUrlMin }}</a>
              โดยบริษัท โรโบลิงโก้ จำกัด (บริษัทฯ)
              คำนึงถึงความเป็นส่วนตัวของลูกค้า โดย
              ขอสัญญาว่าจะเก็บข้อมูลของท่านเป็นความลับอย่างดีที่สุด
            </p>
            <p>
              เมื่อผู้ใช้บริการเข้าใช้เว็บไซต์ของ
              <a :href="currentUrl" target="_BLANK">{{ currentUrlMin }}</a>
              และ/หรือเมื่อเข้าเป็นสมาชิก
              แสดงว่าคุณยอมรับข้อกำหนดของนโยบายความเป็นส่วนตัวนี้
              หากคุณไม่ยอมรับนโยบายความเป็นส่วนตัว
              กรุณายุติการเข้าชมและการใช้เว็บไซต์นี้
              กรุณาอ่านและทำความเข้าใจนโยบายความเป็นส่วนตัว
              ก่อนลงทะเบียนสมัครเป็นสมาชิกเพื่อเข้าใช้บริการเว็บไซต์เพื่อผลประโยชน์สูงสุดของท่าน
            </p>

            <h3>การเก็บรวบรวมและการใช้ข้อมูล</h3>
            <p>
              บริษัทฯ จะเก็บรวบรวมข้อมูลชื่อ นามสกุล ที่อยู่การจัดส่ง เพศ
              ความสนใจส่วนตัวของท่าน และข้อมูลพื้นฐานอื่นๆ
              เมื่อท่านได้เชื่อมต่อกับระบบ
              โดยข้อมูลที่ถูกเก็บรวบรวมทางออนไลน์จะได้รับการเปิดเผยเฉพาะภายในเครือบริษัทฯเพื่อการดำเนินการภายในเท่านั้น
              เมื่อเสร็จสิ้นกระบวนการลงทะเบียนทั้งหมดแล้ว
              ท่านจะมีสิทธิทุกประการในการเป็นสมาชิกเว็บไซต์ ทั้งนี้
              รวมถึงการได้รับข้อมูลข่าวสาร
              สิทธิพิเศษและการเข้าร่วมกิจกรรมส่งเสริมการขายต่างๆ ของเว็บไซต์
              ข้อมูลส่วนบุคคลที่เราเก็บรวมรวมไว้นั้น จะถูกใช้ดังต่อไปนี้
            </p>

            <ul class="mb-4">
              <li>เพื่อการจัดส่งสินค้าที่ท่านสั่งซื้อ</li>
              <li>
                เพื่ออัพเดทข้อมูลการส่งสินค้า
                รวมไปถึงในกรณีที่ผู้ใช้บริการต้องการบริการอื่นๆ เพิ่มเติม
              </li>
              <li>เพื่อการให้ข้อมูลสินค้าที่เกี่ยวข้อง</li>
              <li>
                เพื่อวัตถุประสงค์ในการตรวจสอบการใช้งานเว็บไซต์
                นอกจากนี้ทางบริษัทฯ ยังใช้ข้อมูลและสถิติที่รวบรวมต่างๆ
                ในการวิเคราะห์
                เพื่อคัดเลือกสินค้าและบริการที่เหมาะสมที่สุดสำหรับสมาชิก
                ช่วยปรับปรุงเว็บไซต์และบริการ
                และอาจให้ข้อมูลดังกล่าวแก่บุคคลอื่น
                ข้อมูลสถิติดังกล่าวจะไม่รวมถึงข้อมูลที่สามารถใช้ในการระบุตัวตนของใคร
              </li>
              <li>
                อีกทั้งบริษัทฯ อาจส่งอีเมลถึงท่านเพื่อแจ้งข้อมูลข่าวสาร
                สิทธิพิเศษและกิจกรรมส่งเสริมการขาย
              </li>
            </ul>

            <h3>Refund policy</h3>
            <strong>การเปลี่ยนและคืนสินค้า</strong>
            <p>
              เนื่องจากสินค้าของ
              <a :href="currentUrl" target="_BLANK">{{ currentUrlMin }}</a>
              เป็นสินค้าที่ทางร้านค้าผู้ขายในเครือจะนำมาขายผ่านทางระบบ
              เราจึงไม่มีนโยบายรับคืนสินค้า อย่างไรก็ตาม
              ผู้ซื้อสามารถติดต่อร้านค้าผู้ขายโดยตรงเพื่อเปลี่ยนหรือคืนสินค้า
              กรณีที่ผู้ขายไม่ยอมรับการคืนเงินสินค้า เกิด'ข้อพิพาท'
              ทางทีมงานผู้เชี่ยวชาญของ
              <a :href="currentUrl" target="_BLANK">{{ currentUrlMin }}</a>
              จะเป็นผู้ไกล่เกลี่ยด้วยความยุติธรรม
            </p>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outline :color="theme.color" @click="$emit('close')">{{
            $t('Accept')
          }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ModalDialog from '@/components/ModalDialog.vue'
import { mapGetters } from 'vuex'
export default {
  props: {
    pageid: { default: null }
  },
  components: {
    ModalDialog
  },
  computed: {
    ...mapGetters({
      theme: 'getTheme'
    }),
    currentUrl() {
      return window.location.origin
    },
    currentUrlMin() {
      return window.location.hostname
    }
  }
}
</script>

<style scoped>
.term-and-condition p {
  text-indent: 30px;
}
</style>
